import { PureComponent } from 'preact-compat'
import { h, ComponentChild, ComponentChildren } from 'preact'
import { isChangeEvent, isInputClickEvent } from '../../libs/typeGuards'
import classNames from 'classnames'
import Icon from '../../preact-components/assets'

export const createRandomString = (length: number) => {
  let str = ''
  while (str.length < length) {
    str += Math.random().toString(36).substr(2)
  }
  return str
}

interface Props {
  maxlength?: number
  title?: ComponentChild
  meta?: ComponentChildren
  qaClasses?: string
  error?: string
  type?: string
  value?: string | number | string[]
  checked?: boolean | string
  name?: string
  min?: number
  max?: number
  id?: string
  onChange?: (e: ChangeEvent) => void
  onClick?: () => void
  onBlur?: () => void
  onKeyUp?: (e: ChangeEvent) => void
  onChangeCallback?: (e: ChangeEvent) => void
  onChangeCheckbox?: (e: ClickEvent<HTMLInputElement>) => void
  required?: boolean
  optional?: boolean
  readOnly?: boolean | string
  placeholder?: string
  disabled?: boolean
  pattern?: string
  customInput?: ComponentChildren
  inline?: boolean
  formGroupClasses?: string
  hasError?: boolean
  newStyle?: boolean
  key?: number | string
  showIconBeforeErrorMessage?: boolean
}

class InputGroup extends PureComponent<Props> {
  randomId: string

  constructor (props: Props) {
    super()
    this.randomId = props.id ?? createRandomString(8)
  }

  render (props: Props) {
    const restriction = typeof props.maxlength !== 'undefined' && !props.newStyle
      ? <span className='restriction pull-right'>Max. {props.maxlength} characters</span>
      : null
    const addErrorStyleToInput = ((props.error && props.error !== '') ?? props.hasError)

    return (
      <div className={classNames(props.formGroupClasses, 'form-group', props.newStyle && 'form-group--new-style')}>
        <div class={classNames({ inline: props.inline })}>
          <label for={this.randomId} className={props.title ? undefined : 'hide-label'}>{props.title}</label>{props.optional ? ' (optional)' : null}
          {restriction}
          {props.meta ? <p>{props.meta}</p> : null}
          {
        props.customInput
          ? props.customInput
          : <input
              className={`form-control ${props.qaClasses ?? ''} ${addErrorStyleToInput ? 'validation-error' : ''}`}
              type={props.type}
              id={this.randomId}
              value={props.value}
              checked={!!props.checked}
              name={props.name}
              min={props.min}
              max={props.max}
              onBlur={() => {
                if (props.onBlur) {
                  props.onBlur()
                }
              }}
              onClick={e => {
                if (props.onChangeCheckbox && isInputClickEvent(e)) {
                  props.onChangeCheckbox(e)
                  return
                }
                if (props.onClick && isInputClickEvent(e)) {
                  props.onClick()
                }
              }}
              onChange={e => {
                if (props.onChange && isChangeEvent(e)) {
                  props.onChange(e)
                }
                if (props.onChangeCallback && isChangeEvent(e)) {
                  props.onChangeCallback(e)
                }
              }}
              onKeyUp={e => {
                if (props.onKeyUp) {
                  // @ts-expect-error
                  props.onKeyUp(e)
                }
              }}
              required={props.required}
              disabled={props.disabled}
              readOnly={!!props.readOnly}
              maxLength={props.maxlength}
              placeholder={props.placeholder}
              pattern={props.pattern}
            />
      }
        </div>
        {props.error && props.error !== ''
          ? <div className='validation-error error-message'>
            {props.showIconBeforeErrorMessage && <Icon customClass='icon-warning' icon='warning' />}
            <span className='error-message-text'>{props.error}</span>
          </div>
          : null}
      </div>
    )
  }
}

export default InputGroup
